import { get, create, update, remove } from "@/utill/getData";

export function login(data) {
  return create("/login", data);
}

export function getInfo() {
  return get("/userInfo");
}

export function logout() {
  return create("/logout");
}

export function getUserList(filter) {
  if (filter) {
    return get(
      `/users?orgnId=${filter.orgnId}&useYn=${filter.useYn}&userName=${filter.userName}`
    );
  } else {
    return get(`/users`);
  }
}

export function addUser(param) {
  return create("/users", param);
}

export function updateUser(param) {
  return update(`/users/${param.userId}`, param);
}

export function removeUser(userId) {
  return remove(`/users/${userId}`);
}
